// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__z45zR","content":"styles_content__wE7j1"};